import { Popper, PopperProps } from '@vkontakte/vkui/unstable';
import React, { useRef } from 'react';
import { useWebSearchClickAway } from 'reactApp/ui/Header/WebSearch/hooks/useWebSearchClickAway';

interface IProps extends PopperProps {
    targetRef: React.RefObject<HTMLElement>;
    onClickAway: () => void;
}

export const Popup: React.FC<IProps> = ({ targetRef, onClickAway, children, ...rest }) => {
    const contentRef = useRef<HTMLDivElement>(null);
    useWebSearchClickAway({ ref: contentRef, rootRef: targetRef, onClickAway });

    return (
        <Popper targetRef={targetRef} forcePortal={false} {...rest}>
            <div ref={contentRef}>{children}</div>
        </Popper>
    );
};

Popup.displayName = 'Popup';
